import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=9e3e016c&scoped=true&lang=pug"
import script from "./RecoveryPassword.js?vue&type=script&lang=js&external"
export * from "./RecoveryPassword.js?vue&type=script&lang=js&external"
import style0 from "./RecoveryPassword.sass?vue&type=style&index=0&id=9e3e016c&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3e016c",
  null
  
)

export default component.exports